module.exports = __webpack_public_path__ + "static/media/java-beginner.e26bd982.png";